import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Route } from '@angular/router';

import { NetworkHelperService } from '../../_services/network-helper.service';
import { FORMS, API, CODFUNC, GENERALES } from '../../_config/strings';
import { Subject } from 'rxjs/Subject';
import { Usuario } from '../../_model/Usuario';
import { Cliente } from '../../_model/Cliente';
import Swal from 'sweetalert2';
import * as moment from 'moment';
import { ChatService } from '../../_services/chat.service';
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import swal from 'sweetalert2';
import { IMyDpOptions, MyDatePicker, MyDatePickerModule } from 'mydatepicker';
import { resolve } from '../../../../node_modules/@types/q';
import 'leaflet-routing-machine';
import { Producto } from '../../_model/Producto';

declare let L;
declare var $: any;

@Component({
  selector: 'app-ver-cotizacion',
  templateUrl: './ver-cotizacion.component.html',
  styleUrls: ['./ver-cotizacion.component.scss']
})

export class VerCotizacionComponent implements OnInit {

  // Propiedades de dataTable
  dtOptions: DataTables.Settings = {
    pageLength: 8,
    lengthChange: false,
    info: false
  };

  // Obserbables
  dtTrigger: Subject<any> = new Subject();

  // Strings
  FORMS: any;
  API: any;
  GENERALES: any;
  public usuario: Usuario = new Usuario();
  public cliente: Cliente = new Cliente();

  // Form
  formCliente = '';
  formContacto = '';
  formDescripcion = '';
  formObra = '';
  formTelefono = '';
  formCelular = '';
  formEmail = '';
  formIva;
  fechaCotizacion = '';
  fechaCotizacionFormato = '';
  ordenTipo = '';
  formJustificacion = '';
  // Form

  // Botones
  btnImprimir = false;
  boolCotizacionAceptada = false;
  boolOrdenTipo = true;
  // Botones

  // Variables de arrays
  arrayListarProductos = [];
  arrayMaterial = [];
  arrayMano = [];
  arrayVehiculos = [];
  arrayProductos = [];
  arraySolicitudLista = [];

  // Variables varias
  solicitudListaNombre;
  solicitudListaId;
  nombreListaSucursal = '';
  idCotizacion: Number;
  porcentajeAumento = 0;
  sumaRenta;
  sumaRentaImp;
  sumaCantidad;
  sumaCantidadImp;
  sumaPeso;
  sumaPesoImp;
  sumaVenta;
  sumaVentaImp;
  resultadoDescuentoVenta;
  rentaDiaria;
  rentaDiariaImp;
  aumentoProducto;
  rentaSDias;
  rentaSdiasImp;
  rentaQDias;
  rentaQdiasImp;
  resultadoDiasRenta;
  resultadoDiasRentaImp;
  porcentajeDescuento = 0;
  resultadoPorcentajeDescuento;
  resultadoPorcentajeDescuentoImp;
  diasDeRenta = 0;
  fletesTotal;
  numeroViajes;
  unidadViaje;
  desmontaje;
  desmontajeImp;
  montaje;
  montajeImp;
  iva: Number;
  subTotal;
  subtotalImp;
  costoTotal;

  nRendimiento = 1;
  rendimiento;

  // loginLoader;
  fechaFin = moment().format('DD-MMM-YYYY');
  estatusCotizacionDescuento = '';

  // Mapa
  // Coordenadas
  latitud = 0;
  longitud = 0;
  mapaLongitud;
  mapaLatitud;

  // Todo lo que tenga que ver con manos de obra
  altura = 10;
  personas = 0;
  manoDeObraCollapse = false;
  fletesCollapse = false;
  iconoMano = 'mdi-arrow-down-bold-circle-outline';
  iconoFlete = 'mdi-arrow-down-bold-circle-outline';
  jornales: number;
  jornalesImp;
  pay;
  horasPersonas = 0;
  jornalesPersonas = 0;

  // Imprevistos
  imprevistos0 = '0%';
  imprevistos5 = '5%';
  imprevistos10 = '10%';
  imprevistos15 = '15%';
  imprevistos20 = '20%';
  // Imprevistos

  loginLoader = false;

  // Conceptos Varios
  Transporte = 0;
  Accesos = 0;
  Descargas = 0;
  equipoSeguridad = 0;
  tiemposMuertos = 0;
  Preparacion = 0;
  Acarreos = 0;
  Estructuras = 0;
  consumibles = 0;
  Gastos = 0;
  Financiamiento = 0;
  Tramites = 0;
  Certificados = 0;
  tiemposExtras = 0;
  diasInhabiles = 0;
  Viaticos = 0;
  Traslados = 0;
  Imprevistos = 0;
  Comidas = 0;
  costoTotalManoObra = 0;
  cantidadHoras;
  cantidadHorasTotal;
  cantidadHorasTotalImp;

  // Traslados
  sumaAvion;
  sumaBarco;
  sumaTaxi;
  sumaAutobus;
  sumaOtro;
  totalTotal = 0;
  totalTotalImp;

  // Traslado
  avionCosto = 0;
  avionViajes = 0;
  autobusCosto = 0;
  autobusViajes = 0;
  barcoCosto = 0;
  barcoViajes = 0;
  taxiCosto = 0;
  taxiViajes = 0;
  otroCosto = 0;
  otroViajes = 0;

  avionCheck;
  barcoCheck;
  autobusCheck;

  sumaTrasladosTotal = 0;
  sumaTrasladosTotalImp;
  pasarSumasTemporales = 0;
  totalManoDeObra = 0;
  costoVenta = 0;
  costoVentaImp;

  checkRecoleccion;

  salarioChofer = 0;
  salarioAyudanteGene = 0;
  conFlete;

  // FLETES
  vehiculoId;
  distanciaMetros;
  precioGasolina;
  gastoCombustible = 0;
  gastoCombustibleVista = 0;
  gastoCombustibleVistaImp;
  gastoExtra = 0;
  cantidadColchon = 30;
  rutaMapa = [];
  sucursalNombre = '';
  sucursalLatitud = '';
  sucursalLongitud = '';
  surusalDireccion = '';
  sucursalTelefono = '';
  distanciaKm = 0;
  distanciaKmImp;
  distanciaRedonda = 0;
  imprevisto = 0;
  vehiculo: any;
  vehiculo2: any;
  banderaVehiculo2 = false;
  vehiculoNombre;
  vehiculo2Nombre;
  vehiculoCombustiblePrecio: any;
  vehiculoCombustibleTipo;
  vehiculoPrecio;
  vehiculoRendimiento;
  vehiculoTrabajoReal;
  gastoCasetas = 0;
  operacionTrabajoReal;
  operacionTotalVehiculares;
  operacionTotalVehicularesImp;
  operacionTotalVehicularesVista;
  operacionTotalVehicularesVistaImp;
  // Fletes viáticos
  alojamientoDias = 0;
  desayunosDias = 0;
  comidasDias = 0;
  cenasDias = 0;
  alojamientoInput = 0;
  desayunosInput = 0;
  comidasInput = 0;
  cenasInput = 0;
  acarreosTotal = 0;
  acarreosTotalImp;
  desayunosTotal = 0;
  desayunosTotalImp;
  comidasTotal = 0;
  comidasTotalImp;
  cenasTotal = 0;
  cenasTotalImp;
  totalViaticos = 0;
  totalViaticosImp;
  // Fletes viáticos
  // Fletes traslados personal
  fletesAvion = 0;
  fletesAutobuses = 0;
  fletesTaxis = 0;
  fletesOtro = 0;
  fAvionInput = 0;
  fAutobusInput = 0;
  fTaxiInput = 0;
  fOtroInput = 0;
  subTotalAvionFletes = 0;
  subTotalAutobusFletes = 0;
  subTotalTaxiFletes = 0;
  subTotalOtroFletes = 0;
  totalFletesTraslados = 0;
  totalFletes = 0;
  totalFletesImp;
  // Fletes traslados personal
  // FLETES

  // Select´s
  selectMontaje = 'Montaje';
  selectVenta = 'Venta';
  selectRenta = 'Renta';
  numeros = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  alturaSelect = [10, 20, 30, 40];
  personasSelect = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  numerosViaticos = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
  imprevistos = [0, 200, 400, 600, 800, 1200, 1400, 1600];
  // Select´s

  idSucursal: Number;

  // bandera para el control del observable datatrigger
  banderaDT = true;
  banderaDescuento = false;

  // Swal
  referencia;
  fechaObra;
  horaObra;

  // MyDATEPicker
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'yyyy/mm/dd',
    markCurrentDay: true,
    markCurrentMonth: true,
  };

  constructor(
    private route: ActivatedRoute,
    private network: NetworkHelperService,
    private ruta: Router,
    private chat: ChatService
    ) {
      this.API = API;
      this.GENERALES = GENERALES;
      this.idCotizacion = Number(this.route.snapshot.paramMap.get('idCotizacion'));
      this.usuario = JSON.parse(localStorage.getItem('usuario'));
    }

  ngOnInit() {
    this.listarProductos();
    this.detallesCotizacion();
    // setTimeout(() => {this.mapa(); }, 1500);
    setTimeout(() => {this.mapa(); }, 1500);
  }

  // Mapa
  mapa() {
    // declaracion de variables globales en la aplicación de mapa
    var arrayMarcador = [];
    var mapaSelect;
    var mapaRutaPredeterminada;

    // declaracion del mapa
    var map = L.map('map', { /*var map será nuestra variable global y principal, aquí la estamos seteando, asignándole L.map qie es el objeto vacío de la clase Leaflet que estamos llamando y enviándole el “map” que es el ID de nuestro DIV anteriormente creado. */
      dragging: true,
      touchZoom: true,
      scrollWheelZoom: true,
      doubleClickZoom: true,
      boxZoom: true,
      tap: true,
      keyboard: false,
      contextmenu: true,
      contextmenuWidth: 140,
      contextmenuItems: [{
          text: 'Colocar Marcador',
          callback: colocarMarcador
      }, {
        text: 'Remover Marcador',
        callback: removeLayer

      }, {
          text: 'Centrar el mapa aqui',
          callback: centerMap
      }
        , '-', {
          text: 'Zoom +',
          // icon: 'images/zoom-in.png',
          callback: zoomIn
      }, {
          text: 'Zoom -',
         // icon: 'images/zoom-out.png',
          callback: zoomOut
      }
      ],
      fullscreenControl: true,
      fullscreenControlOptions: {
          position: 'topleft'
        }
    }).setView([22.8196273667, -99.9503588558], 5);

    // el tile layer son las capas, en este caso es una capa de mapa(direcciones)
    L.tileLayer('http://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', { /*Usamos el servicio como Tile para desplegar el mapa dependiendo del mosaico en pantalla.*/
      maxZoom: 19,
      maxNativeZoom: 19,
      zoomDelta: 0.25,
      zoomSnap: 0,
      attribution: 'Map data &copy; OpenStreetMap contributors' // opciones
    }).addTo(map); // aquí agregamos el mapa base (WMS) a el map (que es nuestra objeto map)

    // es el icono para agregar marcadores
    var myIcon = L.icon({
      iconUrl: '../../../assets/images/marker-icon.png',
      iconSize: [30, 55],
      iconAnchor: [22, 55],
      popupAnchor: [-3, -76],
      shadowUrl: '../../../assets/images/marker-shadow.png',
      shadowSize: [68, 55],
      shadowAnchor: [22, 55]
    });
    // El siguinte modulo es para el buscador, en base a librerias y una API externa es como se buscan las direcciones
    L.Control.geocoder({
      defaultMarkGeocode: false,
      collapsed: false
  })
  .on('markgeocode', function(e) {
      var bbox = e.geocode.bbox;
      var poly = L.polygon([
           bbox.getSouthEast(),
           bbox.getNorthEast(),
           bbox.getNorthWest(),
           bbox.getSouthWest()
      ]);
      map.fitBounds(poly.getBounds());
  }).addTo(map);

  // Como esta es la vista para ver-Cotizador, tendremos que llamar a un metodo instantaneo para poder agregar el marcador que se guardo en ver cotizador
  // primero validaremos si existen la latitud y longitud del mapa
  this.sucursalLatitud = $('#latitudDeSucursal').val();
  this.sucursalLongitud = $('#longitudDeSucursal').val();
  this.latitud = $('#latitud').val();
  this.longitud = $('#longitud').val();

  // entrara en el if si todos poseen la informacion
  if ((this.latitud && this.longitud) && (this.sucursalLongitud && this.sucursalLatitud) ) {
    // Como esto solo existira una vez, llamaremos al metodo directamente
    // Ahora agregaremos el marcador con las cordenadas existentes
    var marker = L.marker([this.latitud, this.longitud], {icon: myIcon}).addTo(map);
    // el marcador solo para el final de la ruta
    // agregaremos la ruta
    mapaRutaPredeterminada = L.Routing.control({
      waypoints: [
        L.latLng(this.latitud, this.longitud),
        L.latLng(this.sucursalLatitud, this.sucursalLongitud)
      ],
      routeWhileDragging: true,
      showAlternatives: false
      }).on('routesfound', function (e) {
        const distance = e.routes[0].summary.totalDistance;
        const min = e.routes[0].summary.totalTime;
        $('#distanciaM').val(distance);
      }).addTo(map);
      mapaRutaPredeterminada.hide();

  }
    // Las siguientes son funciones para el menu de contexto

    // centrar el mapa
    function centerMap (e) {
      map.panTo(e.latlng);
    }
    // colocar el marcador icono
    function colocarMarcador (e) {
      // console.log(mapaRutaPredeterminada);
      if (mapaRutaPredeterminada.length !== 0) {
        mapaRutaPredeterminada.remove();
        mapaRutaPredeterminada = [];
        removeLayer(e);
      }
      if (arrayMarcador.length === 0 || typeof(arrayMarcador.length) === 'undefined') {
        arrayMarcador.push('yes');
      var marker = L.marker(e.latlng, {icon: myIcon}).addTo(map);
      $('#latitud').val(e.latlng.lat);
      $('#longitud').val(e.latlng.lng)

      // Machine route
      this.mapaSelect = L.Routing.control({
        waypoints: [
          L.latLng(e.latlng.lat, e.latlng.lng),
          L.latLng(this.sucursalLatitud, this.sucursalLongitud)
        ],
        routeWhileDragging: true,
        showAlternatives: false
        }).on('routesfound', function (e) {
          const distance = e.routes[0].summary.totalDistance;
          const min = e.routes[0].summary.totalTime;
          $('#distanciaM').val(distance);
        }).addTo(map);

        this.mapaSelect.hide();

      } else {

        // Limpiamos todas las varibales en el mapa
        removeLayer(e);
        arrayMarcador = [];
        this.mapaSelect.remove();
        this.mapaSelect = [];

        // El array marcador es para controlar el flujo al insertar un nuevo marcado de ruta
        arrayMarcador.push('yes');

        var marker = L.marker(e.latlng, {icon: myIcon}).addTo(map);
        this.longitud = e.latlng.lng;
        this.latitud = e.latlng.lat;
        $('#latitud').val(this.latitud);
        $('#longitud').val(this.longitud);

      // Machine route
      this.mapaSelect = L.Routing.control({
        waypoints: [
          L.latLng(this.latitud, this.longitud),
          L.latLng(this.sucursalLatitud, this.sucursalLongitud)
        ],
        routeWhileDragging: true,
        showAlternatives: false
        }).on('routesfound', function (e) {
          const distance = e.routes[0].summary.totalDistance;
          const min = e.routes[0].summary.totalTime;
          $('#distanciaM').val(distance);
          // console.log( distance );
        }).addTo(map);
        this.mapaSelect.hide();

      }
    }

    // Remueve el marcador icono
    function removeLayer(e) {
      map.eachLayer(function(layer) {
        if (layer.dragging) {
          map.removeLayer(layer);
        }
      });
      mapaSelect = [];
    }

    // Le da zoom con click derecho
    function zoomIn (e) {
      map.zoomIn();
    }

    // Quita zoom en dos puntos
    function zoomOut (e) {
      map.zoomOut();
    }
    this.generarManoDeObra();

  }
  // Mapa

  // Listar productos
  // La funcion listar productos para la lista de productos por si quiere agregar más
  listarProductos() {
    const idCJSON = {
      cotizacionId: this.idCotizacion
    };
    this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.productos  + '/' + this.API.user.lista,
      'POST',
      idCJSON)
      .subscribe((response: any) => {
        // console.log( response );
        if (response.Estatus === 200) {
          for (const productos of response.Mensaje.productos) {
            this.arrayListarProductos.push({
              id: productos.productoId,
              codigo: productos.codigo,
              descripcion: productos.descripcion,
              familia: productos.familia,
              pVenta: productos.precioVenta,
              pRenta: productos.precioRenta,
              peso: productos.peso,
            });
          }
          if (this.banderaDT) {
            this.dtTrigger.next();
          }
          // Sucursal
          this.sucursalNombre = response.Mensaje.sucursal.nombre;
          this.sucursalLatitud = response.Mensaje.sucursal.latitud;
          this.sucursalLongitud = response.Mensaje.sucursal.longitud;
          this.surusalDireccion = response.Mensaje.sucursal.direccion;
          this.sucursalTelefono = response.Mensaje.sucursal.telefono;
          if ( this.sucursalNombre === 'Tijuana' || this.sucursalNombre === 'Monterrey' ) {
            this.iva = 0.08;
            this.formIva = '8%';
          } else {
            this.iva = 0.16;
            this.formIva = '16%';
          }
          // Sucursal
          for ( const vehiculo of response.Mensaje.vehiculos ) {
            this.arrayVehiculos.push({
              vehiculoId: vehiculo.vehiculoId,
              vehiculoNombre: vehiculo.nombre,
              vehiculoTipo: vehiculo.tipo,
              vehiculoCapacidad: vehiculo.capacidad,
              vehiculoRendimiento: vehiculo.rendimiento,
              vehiculoCombustible: vehiculo.combustible
            });
          }
        } else {
          Swal('Error ' + response.Estatus, response.Mensaje, 'error');
        }
      }, err => {
        console.log(err);
        Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
      }
    );
  }
  // Listar productos

  // Detalles cotizacion
  detallesCotizacion() {
    const JSONDET = {
      cotizacionId: this.idCotizacion
    };
    this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.detalles,
      'POST',
      JSONDET
    ).subscribe((response: any) => {
      console.log(response);
      this.diasDeRenta = response.Mensaje.cantidadDias;
      this.mapaLatitud = response.Mensaje.latitud;
      this.mapaLongitud = response.Mensaje.longitud;
      $('#latitud').val(this.mapaLatitud);
      $('#longitud').val(this.mapaLongitud);
      // Sucursal
      this.sucursalNombre = response.Mensaje.sucursal.nombreSuc;
      $('#latitudDeSucursal').val(response.Mensaje.sucursal.latlng.latitud);
      $('#longitudDeSucursal').val(response.Mensaje.sucursal.latlng.longitud);
      this.estatusCotizacionDescuento = response.Mensaje.estatus.estatus;
      if ( this.estatusCotizacionDescuento === 'ORDAUTO') {
        this.boolCotizacionAceptada = true;
      }
      this.Acarreos = response.Mensaje.manoObra.acarreos;
      this.Accesos = response.Mensaje.manoObra.accesos;
      this.altura  = response.Mensaje.manoObra.altura;
      // Traslados personal
      this.avionViajes = response.Mensaje.manoObra.avionViajes;
      this.avionCosto = response.Mensaje.manoObra.avionCosto;
      this.avionCheck = response.Mensaje.manoObra.avionCheck;
      this.autobusViajes = response.Mensaje.manoObra.autobusViajes;
      this.autobusCosto = response.Mensaje.manoObra.autobusCosto;
      this.autobusCheck = response.Mensaje.manoObra.autobusCheck;
      this.barcoViajes = response.Mensaje.manoObra.barcoViajes;
      this.barcoCosto = response.Mensaje.manoObra.barcoCosto;
      this.barcoCheck = response.Mensaje.manoObra.barcoCheck;
      this.Certificados = response.Mensaje.manoObra.certificados;
      this.Comidas = response.Mensaje.manoObra.comidas;
      this.consumibles = response.Mensaje.manoObra.consumibles;
      this.Descargas = response.Mensaje.manoObra.descargas;
      this.diasInhabiles = response.Mensaje.manoObra.diasInhabiles;
      this.equipoSeguridad = response.Mensaje.manoObra.equipoSeguridad;
      this.Imprevistos = response.Mensaje.manoObra.imprevistos;
      // Jornal
      this.otroCosto = response.Mensaje.manoObra.otroCosto;
      this.otroViajes = response.Mensaje.manoObra.otroViajes;
      this.personas = response.Mensaje.manoObra.personas;
      this.Preparacion = response.Mensaje.manoObra.preparacionMaterial;
      // Rendimiento
      this.taxiCosto = response.Mensaje.manoObra.taxiCosto;
      this.taxiViajes = response.Mensaje.manoObra.taxiViajes;
      this.tiemposExtras = response.Mensaje.manoObra.tiemposExtra;
      this.tiemposMuertos = response.Mensaje.manoObra.tiemposMuertos;
      this.Tramites = response.Mensaje.manoObra.tramites;
      this.porcentajeDescuento = response.Mensaje.porcentajeDescuento;
      this.porcentajeAumento = response.Mensaje.porcentajeAumento;
      // Fecha
      this.fechaFin = response.Mensaje.fechaCotizada;
      // this.fechaFin = moment().locale('es').format('LL');
      // fechaFin = moment().locale('es').format('LL');
      // Fletes
      this.conFlete = String(response.Mensaje.flete.conFlete),
      this.vehiculoNombre = response.Mensaje.flete.vehiculo.tipo;
      this.vehiculoCombustiblePrecio = response.Mensaje.flete.vehiculo.combustible[0].precio;
      this.vehiculoTrabajoReal = response.Mensaje.flete.vehiculo.rendimiento[0].trabajo_real;
      let distanciaResponse = response.Mensaje.flete.distancia;
      distanciaResponse = ((distanciaResponse - 50) / 2) * 1000;
      $('#distanciaM').val(distanciaResponse);
      this.gastoExtra = response.Mensaje.flete.gastoExtra;
      this.gastoCasetas = response.Mensaje.flete.gastoCasetas;
      this.checkRecoleccion = response.Mensaje.flete.recoleccion;
      // Viáticos
      this.alojamientoInput = response.Mensaje.flete.viaticos.alojamientoCosto;
      this.alojamientoDias = response.Mensaje.flete.viaticos.alojamientoDias;
      this.desayunosInput = response.Mensaje.flete.viaticos.desayunoCosto;
      this.desayunosDias = response.Mensaje.flete.viaticos.desayunoDias;
      this.comidasInput = response.Mensaje.flete.viaticos.comidasCosto;
      this.comidasDias = response.Mensaje.flete.viaticos.comidasDias;
      this.cenasInput = response.Mensaje.flete.viaticos.cenasCosto;
      this.cenasDias = response.Mensaje.flete.viaticos.cenasDias;
      // Traslados personal
     /* this.fAvionInput = response.Mensaje.flete.viaticos.avionCosto;
      this.fletesAvion = response.Mensaje.flete.viaticos.avionViajes;
      this.fAutobusInput = response.Mensaje.flete.viaticos.autobusCosto;
      this.fletesAutobuses = response.Mensaje.flete.viaticos.autobusViajes;
      this.fTaxiInput = response.Mensaje.flete.viaticos.taxiCosto;
      this.fletesTaxis = response.Mensaje.flete.viaticos.taxiViajes;
      this.fOtroInput = response.Mensaje.flete.viaticos.otroCosto;
      this.fletesOtro = response.Mensaje.flete.viaticos.otroViajes;
      */
     this.sumaRenta = 0;
     if (response.Mensaje.porcentajeAumento !== 0) {
      for (const productos of response.Mensaje.material) {
        const multi = (productos.rentaMensual * (response.Mensaje.porcentajeAumento / 100)) + productos.rentaMensual;
        this.arrayMaterial.push({
          id: productos.materialId,
          codigo: productos.codigo,
          descripcion: productos.descripcion,
          peso: productos.peso,
          cantidad: productos.cantidad,
          cantidadImp: Intl.NumberFormat('es-MX').format(productos.cantidad),
          venta: productos.venta,
          ventaImp: Intl.NumberFormat('es-MX').format(productos.venta),
          rentaMensual: Number(multi).toFixed(4),
          rentaMensualSinModificadores: productos.rentaMensual,
          // rentaMensual: productos.rentaMensual,
          familia: productos.familia,
          // rentaMensualSinModificaciones: productos.rentaMensualSinModificaciones,
          importeRenta: (productos.cantidad * multi).toFixed(2),
          importeRentaImp: Intl.NumberFormat('es-MX').format(productos.cantidad * multi),
          importeVenta: productos.importeVenta.toFixed(2),
          importeVentaImp: Intl.NumberFormat('es-MX').format(productos.importeVenta.toFixed(2)),
          importePeso: productos.importePeso.toFixed(2),
          importePesoImp: Intl.NumberFormat('es-MX').format(productos.importePeso.toFixed(2))
        });
        this.sumaRenta = this.sumaRenta + Number(multi);
        this.sumaRentaImp = Intl.NumberFormat('es-MX').format(this.sumaRenta);
      }
    } else {
      for (const productos of response.Mensaje.material) {
       // const multi = (productos.rentaMensual * (response.Mensaje.porcentajeAumento / 100)) + productos.rentaMensual;
        this.arrayMaterial.push({
          id: productos.materialId,
          codigo: productos.codigo,
          descripcion: productos.descripcion,
          peso: productos.peso,
          cantidad: productos.cantidad,
          cantidadImp: Intl.NumberFormat('es-MX').format(productos.cantidad),
          venta: productos.venta,
          ventaImp: Intl.NumberFormat('es-MX').format(productos.venta),
          rentaMensual: Number(productos.rentaMensual ).toFixed(4),
          rentaMensualSinModificadores: productos.rentaMensual,

          // rentaMensual: productos.rentaMensual,
          familia: productos.familia,
          // rentaMensualSinModificaciones: productos.rentaMensualSinModificaciones,
          importeRenta: productos.importeRenta.toFixed(2),
          importeRentaImp: Intl.NumberFormat('es-MX').format(productos.importeRenta.toFixed(2)),
          importeVenta: productos.importeVenta.toFixed(2),
          importeVentaImp: Intl.NumberFormat('es-MX').format(productos.importeVenta.toFixed(2)),
          importePeso: productos.importePeso.toFixed(2),
          importePesoImp: Intl.NumberFormat('es-MX').format(productos.importePeso.toFixed(2))
        });
        this.sumaRenta = this.sumaRenta + Number(productos.rentaMensual);
        this.sumaRentaImp = Intl.NumberFormat('es-MX').format(productos.rentaMensual);
      }
    }
      // console.log(this.arrayMaterial);
      // Renta diaria
      this.rentaDiaria = (this.sumaRenta / 30).toFixed(2);
      this.rentaDiariaImp = Intl.NumberFormat('es-MX').format(this.rentaDiaria);
      // Renta 7 días
      this.rentaSDias = (this.sumaRenta / 30 * 7).toFixed(2);
      this.rentaSdiasImp = Intl.NumberFormat('es-MX').format(this.rentaSDias);
      // Renta 15 días
      this.rentaQDias = (this.sumaRenta / 2).toFixed(4);
      this.rentaQdiasImp = Intl.NumberFormat('es-MX').format(this.rentaQDias);
      // Cantidad
      this.sumaCantidad = response.Mensaje.cantidadTotal;
      this.sumaCantidadImp = Intl.NumberFormat('es-MX').format(this.sumaCantidad);
      // SumaPeso
      this.sumaPeso =  response.Mensaje.rentaPeso.toFixed(4);
      this.sumaPesoImp =  Intl.NumberFormat('es-MX').format(this.sumaPeso);
      // this.sumaPeso = Number((this.sumaPeso + Number(element.pesoT)).toFixed(4));
      // Porcentajes
          // Resumemn Servicio
          this.diasDeRenta = response.Mensaje.cantidadDias;
          // this.resultadoDiasRenta = (Math.abs(this.sumaRenta / 30) * this.diasDeRenta).toFixed(4);
          this.resultadoDiasRenta = Math.abs(this.rentaDiaria * this.diasDeRenta).toFixed(4);
          this.resultadoDiasRentaImp = Intl.NumberFormat('es-MX').format(this.resultadoDiasRenta);
          // this.resultadoPorcentajeDescuento = Math.abs((this.resultadoDiasRenta * this.porcentajeDescuento) / 100 - this.resultadoDiasRenta);
      // Montaje
          this.montaje = response.Mensaje.montaje;
          this.montajeImp = Intl.NumberFormat('es-Mx').format(this.montaje);
          this.desmontaje = response.Mensaje.desmontaje;
          this.desmontajeImp = Intl.NumberFormat('es-MX').format(this.desmontaje);
      // Fletes
         /* this.numeroViajes = response.Mensaje.noFletes;
          this.unidadViaje = response.Mensaje.costoFlete;
          this.fletesTotal = response.Mensaje.noFletes * response.Mensaje.costoFlete;
          */
      // Totales
          this.subTotal = this.fletesTotal + this.montaje + this.desmontaje;
          this.resultadoPorcentajeDescuento = Math.abs((this.subTotal - ((this.porcentajeDescuento / 100) * this.subTotal)));
          this.resultadoPorcentajeDescuentoImp = Intl.NumberFormat('es-MX').format(this.resultadoPorcentajeDescuento);
          this.costoTotal = Number(((Number(this.resultadoPorcentajeDescuento) * Number( this.iva ) ) + this.resultadoPorcentajeDescuento).toFixed(4));
          // this.costoTotal = (Number(this.subTotal) * 0.16) + this.subTotal;
          this.sumaVenta = Number(response.Mensaje.ventaTotal).toFixed(4);
          this.sumaVentaImp = Intl.NumberFormat('es-MX').format(this.sumaVenta);
          this.totalManoDeObra = this.montaje + this.desmontaje;

      // InfoCliente
      // Form
      this.formCliente = response.Mensaje.clienteCotizado;
      this.formContacto = response.Mensaje.contactoCotizado;
      this.formDescripcion = response.Mensaje.descripcion;
      this.formObra = response.Mensaje.obraCotizada;
      this.formTelefono = response.Mensaje.telefonoCotizado;
      this.formCelular = response.Mensaje.celularCotizado;
      this.formEmail = response.Mensaje.emailCotizado;
      this.fechaCotizacion = response.Mensaje.fecha.split('T')[0];
      this.fechaCotizacionFormato = moment(this.fechaCotizacion).locale('es').format('LL');
      // this.fechaCotizacion = moment().locale('es').format('LL');
      this.ordenTipo = response.Mensaje.tipoCotizacion;
      
      if (this.ordenTipo === 'Venta') {
        this.boolOrdenTipo = false;
      } else {
        this.boolOrdenTipo = true;
      }
      this.formJustificacion = response.Mensaje.justificacion;
      // Contenido de la impresión
      if (this.ordenTipo === 'Montaje') {
        this.btnImprimir = false;
      } else {
        this.btnImprimir = true;
      }
      // Contenido de la impresión
      // Solicitud de lista de cambios de precios
      this.nombreListaSucursal = response.Mensaje.listaPrecioNombre;
      this.arraySolicitudLista = response.Mensaje.solicitudLista;
      this.solicitudListaNombre = response.Mensaje.solicitudLista.nombre;
      this.solicitudListaId = response.Mensaje.solicitudLista.solicitudListaId;
      }, err => {
        console.log(err);
      });
  }
  // Detalles cotizacion

  // Select tipo de cotización
  selectTipoCotizacion () {
    this.generarFlete();
    if (this.ordenTipo === 'Montaje') {
      this.btnImprimir = false;
    } else {
      this.btnImprimir = true;
      this.totalTotal = 0;
    }
    if (this.ordenTipo === 'Venta') {
      this.boolOrdenTipo = false;
    } else {
      this.boolOrdenTipo = true;
    }
    
    this.generarManoDeObra();
  }
  // Select tipo de cotización

  // Desplegar mano de obra
  desplegarManoObra() {
    if (this.manoDeObraCollapse) {
      this.manoDeObraCollapse = false;
      this.iconoMano = 'mdi-arrow-down-bold-circle-outline';
    } else {
      this.manoDeObraCollapse = true;
      this.iconoMano = 'mdi-arrow-up-bold-circle-outline';
    }
  }
  // Desplegar mano de obra

  // Generar mano de obra
  generarManoDeObra() {
    // primero generamos el rendimiento
    this.generarRendimiento();
    // Lo segundo es generar Jornal
    // this.generarJornal(); <-- Esta comentado, porque solo son los pasos
    // generamos las varibles temporales
    this.variablesTemporales();
    // las funciones de flete
    this.fletesViaticos();
    this.fletesTraslados();
    this.calcularCostosProducto();
    // los traslados de fletes
    this.generarTrasladosManoObra();
    this.generarFlete();
    // generar renta
    this.sumaTotales();
  }
  // Generar mano de obra

  // Generar rendimiento
  generarRendimiento() {
    let porcentajeRendimiento: number = 12.5;
    let nRendimiento: number;
    let procentaje: number;

    let tarimas: number = 40;
    let juntas: number = 40;
    let crucetas: number = 80;
    let marcos: number = 40;
    let vallas: number = 100;
    let sm8: number = 42;
    let templete: number = 100;
    let bases: number = 40;
    let ruedas: number = 40;
    let montantes: number = 30;
    let mensulas: number = 25;
    let rodapies: number = 30;
    let baseDeArranque: number = 30;
    let puntales: number = 20;
    let escalonesMetalicos: number = 30;
    let vigasExtencibles: number = 10;
    let vigadales: number = 20;
    let escalerasMarinas: number = 30;
    let engancheParalelo: number = 30;
    let vigasH20: number = 20;

    switch (true) {
      case this.altura <= 10 && this.altura >= 0:
      {
        this.nRendimiento = 1;
        procentaje = 100;
        break;
      }
      case this.altura <= 20 && this.altura >= 11:
      {
        nRendimiento = 2;
        this.nRendimiento = nRendimiento;
        procentaje = 100 - (nRendimiento * porcentajeRendimiento);
        break;
      }
      case this.altura <= 30 && this.altura >= 21:
      {
        nRendimiento = 3;
        this.nRendimiento = nRendimiento;
        procentaje = 100 - (nRendimiento * porcentajeRendimiento);
        break;
      }
      case this.altura <= 40 && this.altura >= 31:
      {
        nRendimiento = 4;
        this.nRendimiento = nRendimiento;
        procentaje = 100 - (nRendimiento * porcentajeRendimiento);
        break;
      }
      case this.altura >= 41:
      {
        nRendimiento = 5;
        this.nRendimiento = nRendimiento;
        procentaje = 100 - (nRendimiento * porcentajeRendimiento);
        break;
      }
    }

    const rendimientoMarcos =  (procentaje / 100) * marcos;
    const rendimientoTarimas =  (procentaje / 100) * tarimas;
    const rendimientoCrucetas =  (procentaje / 100) * crucetas;
    const rendimientoVallas =  (procentaje / 100) * vallas;
    const rendimientoSm8 =  (procentaje / 100) * sm8;
    const rendimientoJuntas =  (procentaje / 100) * juntas;
    const rendimientoTemplete = ( procentaje / 100 ) * templete;
    const rendimientoBases = ( procentaje / 100 ) * bases;
    const rendimientoRuedas = ( procentaje / 100 ) * ruedas;
    const rendimientoMontantes = ( procentaje / 100 ) * montantes;
    const rendimientoMensulas = ( procentaje / 100 ) * mensulas;
    const rendimientoRodapies = ( procentaje / 100 ) * rodapies;
    const rendimientoBaseDeArranque = ( procentaje / 100 ) * baseDeArranque;
    const rendimientoPuntales = ( procentaje / 100 ) * puntales;
    const rendimientoEscalonesMetalicos = ( procentaje / 100 ) * escalonesMetalicos;
    const rendimientoVigasExtencibles = ( procentaje / 100 ) * vigasExtencibles;
    const rendimientoVigadales = ( procentaje / 100 ) * vigadales;
    const rendimientoEscalerasMarinas = ( procentaje / 100 ) * escalerasMarinas;
    const rendimientoEngancheParalelo = ( procentaje / 100 ) * engancheParalelo;
    const rendimientoVigasH20 = ( procentaje / 100 ) * vigasH20;

    this.rendimiento = procentaje;

    this.generarJornal(
      rendimientoCrucetas,
      rendimientoJuntas,
      rendimientoMarcos,
      rendimientoSm8,
      rendimientoVallas,
      rendimientoTarimas,
      rendimientoTemplete,
      rendimientoBases,
      rendimientoRuedas,
      rendimientoMontantes,
      rendimientoMensulas,
      rendimientoRodapies,
      rendimientoBaseDeArranque,
      rendimientoPuntales,
      rendimientoEscalonesMetalicos,
      rendimientoVigasExtencibles,
      rendimientoVigadales,
      rendimientoEscalerasMarinas,
      rendimientoEngancheParalelo,
      rendimientoVigasH20
    );
  }
  // Generar rendimiento

  // Generar jornal
  generarJornal(
    rendimientoCrucetas,
    rendimientoJuntas,
    rendimientoMarcos,
    rendimientoSm8,
    rendimientoVallas,
    rendimientoTarimas,
    rendimientoTemplete,
    rendimientoBases,
    rendimietoRuedas,
    rendimientoMontantes,
    rendimientoMensulas,
    rendimientoRodapies,
    rendimientoBaseDeArranque,
    rendimientoPuntales,
    rendimientoEscalonesMetalicos,
    rendimientoVigasExtencibles,
    rendimientoVigadales,
    rendimientoEscalerasMarinas,
    rendimientoEngancheParalelo,
    rendimientoVigasH20) {
    var sumaRendimientoJunta:number = 0;
    var sumaRendimientoCrucetas:number = 0;
    var sumaRendimientoMarcos:number = 0;
    var sumaRendimientoSm8:number = 0;
    var sumaRendimientoVallas:number = 0;
    var sumaRendimientoTarimas:number = 0;
    var sumaRendimientoTemplete: number = 0;
    var sumaRendimientoBases: number = 0;
    var sumaRendimietoRuedas: number = 0;
    var sumaRendimientoPuntales: number = 0;
    var sumaRendimientoEscalonesMetalicos: number = 0;
    var sumaRendimientoVigasExtencibles: number = 0;
    var sumaRendimientoVigadales: number = 0;
    var sumaRendimientoVigasH20: number = 0;

    this.arrayMaterial.forEach(element => {

      switch (element.familia) {
        case 'JUNTAS': {
          sumaRendimientoJunta = sumaRendimientoJunta + ((Number(element.cantidad) * 8) / rendimientoJuntas);
          break;
        }
        case 'MARCOS': {
          sumaRendimientoMarcos = sumaRendimientoMarcos + ((Number(element.cantidad) * 8) / rendimientoMarcos);
          break;
        }
        case 'CRUCETAS': {
          sumaRendimientoCrucetas = sumaRendimientoCrucetas + ((Number(element.cantidad) * 8) / rendimientoCrucetas);
          break;
        }
        case 'SM-8': {
          let cincoCaracteres = element.descripcion.slice(0, 5);
          if (cincoCaracteres === 'TRAVE') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoSm8);
          } else if (cincoCaracteres === 'DIAGO') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoSm8);
          } else if (cincoCaracteres === 'LARGU') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoSm8);
          } else if (cincoCaracteres === 'BASE ') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoBaseDeArranque);
          } else if (cincoCaracteres === 'MONTA') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoMontantes);
          } else if (cincoCaracteres === 'RODAP') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoRodapies);
          } else if (cincoCaracteres === 'MENSU') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoMensulas);
          } else if (cincoCaracteres === 'ESCAL') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoEscalerasMarinas);
          } else if (cincoCaracteres === 'ENGAN') {
            sumaRendimientoSm8 = sumaRendimientoSm8 + ((Number(element.cantidad) * 8) / rendimientoEngancheParalelo);
          }
            break;
        }
        case 'TARIMAS': {
          sumaRendimientoVallas = sumaRendimientoVallas + ((Number(element.cantidad) * 8) / rendimientoTarimas);
          break;
        }
        case 'VALLAS': {
          sumaRendimientoTarimas = sumaRendimientoTarimas + ((Number(element.cantidad) * 8) / rendimientoVallas);
          break;
        }
        case 'TEMPLETE': {
          let cincoCaracteres = element.descripcion.slice(0, 5);
          if ( cincoCaracteres === 'CUADR' ) {
            sumaRendimientoTemplete = sumaRendimientoTemplete + ( (Number(element.cantidad) * 8) / rendimientoTemplete );
          }
          break;
        }
        case 'BASES': {
          sumaRendimientoBases = sumaRendimientoBases + ((Number(element.cantidad) * 8) / rendimientoBases);
          break;
        }
        case 'RUEDAS': {
          sumaRendimietoRuedas = sumaRendimietoRuedas + ((Number(element.cantidad) * 8) / rendimietoRuedas);
          break;
        }
        case 'PUNTALES': {
          sumaRendimientoPuntales = sumaRendimientoPuntales + ((Number(element.cantidad) * 8) / rendimientoPuntales);
          break;
        }
        case 'ESCALONES METALICOS': {
          sumaRendimientoEscalonesMetalicos = sumaRendimientoEscalonesMetalicos + ((Number(element.cantidad) * 8) / rendimientoEscalonesMetalicos);
          break;
        }
        case 'VIGAS EXTENCIBLES': {
          sumaRendimientoVigasExtencibles = sumaRendimientoVigasExtencibles + ((Number(element.cantidad) * 8) / rendimientoVigasExtencibles);
          break;
        }
        case 'VIGADALES Y DUELAS': {
          sumaRendimientoVigadales = sumaRendimientoVigadales + ((Number(element.cantidad) * 8) / rendimientoVigadales);
          break;
        }
        case 'VIGAS H20': {
          sumaRendimientoVigasH20 = sumaRendimientoVigasH20 + ((Number(element.cantidad) * 8) / rendimientoVigasH20);
          break;
        }
      }

    });
    if ( this.ordenTipo === 'Venta' || this.ordenTipo === 'Renta' ) {
      this.cantidadHoras = 0;
      this.jornales = (this.cantidadHoras / 8);
      this.jornalesImp = Intl.NumberFormat('es-MX').format(this.jornales);
    } else if ( this.ordenTipo === 'Montaje' ) {
      this.cantidadHoras = sumaRendimientoCrucetas + sumaRendimientoJunta + sumaRendimientoMarcos + sumaRendimientoSm8 + sumaRendimientoTarimas + sumaRendimientoVallas + sumaRendimientoTemplete + sumaRendimientoVigasH20 + 8;
      this.jornales = (this.cantidadHoras / 8);
      this.jornalesImp = Intl.NumberFormat('es-MX').format(this.jornales);
    }
    // console.log(sumaRendimientoSm8);
    this.jornadas();
  }
  // Generar jornal

  // Jornadas
  jornadas() {
    var cantidadHorasFloat = ((this.cantidadHoras + this.pasarSumasTemporales));
    this.cantidadHorasTotal = Number(cantidadHorasFloat.toFixed(4));
    this.cantidadHorasTotalImp = Intl.NumberFormat('es-MX').format(this.cantidadHorasTotal);
    // var jornalesFloat = (cantidadHorasFloat / 8);
    if ( this.ordenTipo === 'Montaje' ) {
      var jornalesFloat = (cantidadHorasFloat / 8);
      this.jornales = Math.ceil(Number(jornalesFloat.toFixed(4)));
      this.jornalesImp = Intl.NumberFormat('es-MX').format(this.jornales);
    } else if ( this.ordenTipo === 'Venta' || this.ordenTipo === 'Renta' ) {
      var jornalesFloarDos = (cantidadHorasFloat / 8);
      this.jornales = Math.ceil(Number(jornalesFloarDos.toFixed(4)));
      this.jornalesImp = Intl.NumberFormat('es-MX').format(this.jornales);
    }
    // this.jornales = Math.ceil(Number(jornalesFloat.toFixed(4)));
    if (this.jornales !== 0) {
      this.sumaConceptosVarios();
    }
    this.horasPersonas = Math.ceil(this.cantidadHorasTotal / this.personas);
    this.jornalesPersonas = Math.ceil(jornalesFloat / this.personas);
  }
  // Jornadas

  // Recorrido material
  // Suma conceptos varios
  sumaConceptosVarios() {
    let suma: number;
    suma = Number(this.equipoSeguridad)  + Number(this.Preparacion) + Number(this.consumibles) + Number(this.Gastos) + Number(this.Tramites) + Number(this.Certificados)
    + Number(this.Comidas) + (Number(this.diasInhabiles) * 1750 * this.personas);
    this.costoTotalManoObra = suma;
    let trabajo;
    if (this.jornales === 1) {
      trabajo = 0;
    } else {
      trabajo = this.jornales * 850;
    }
    trabajo = Number(suma) + Number(trabajo);
    trabajo = trabajo + (((Number(this.Imprevistos) / 100) * trabajo ));
    this.montaje =  ((trabajo) * 2) / 3;
    this.desmontaje =  ((trabajo) * 1) / 3;
    this.montaje = Number(this.montaje.toFixed(4));
    this.desmontaje = Number(this.desmontaje.toFixed(4));
    this.totalTotal = Number(trabajo) + this.sumaTrasladosTotal;
    this.totalTotal = Number(this.totalTotal.toFixed(4));
    this.totalTotalImp = Intl.NumberFormat('es-MX').format(this.totalTotal);
    this.sumaTotales();
  }
  // Suma conceptos varios

  // Variables temporales
  variablesTemporales() {
    this.pasarSumasTemporales = Number(this.Accesos) + Number(this.Descargas) + Number(this.tiemposMuertos) + Number(this.Acarreos) + Number(this.tiemposExtras);
    this.jornadas();
  }
  // Variables temporales

  // Traslados mano de obra
  generarTrasladosManoObra() {
    let sumaAvionOp = this.avionCosto * this.avionViajes;
    this.sumaAvion = Intl.NumberFormat('es-MX').format(sumaAvionOp);
    if ( this.avionCheck ) {
        sumaAvionOp = sumaAvionOp * 2;
        this.sumaAvion = Intl.NumberFormat('es-MX').format(sumaAvionOp);
    }
      let sumaAutobusOp = this.autobusCosto * this.autobusViajes;
      this.sumaAutobus = Intl.NumberFormat('es-MX').format(sumaAutobusOp);
    if (this.autobusCheck) {
      sumaAutobusOp = sumaAutobusOp * 2;
      this.sumaAutobus = Intl.NumberFormat('es-MX').format(sumaAutobusOp);
    }
    let sumaBarcoOp = this.barcoCosto * this.barcoViajes;
    this.sumaBarco = Intl.NumberFormat('es-MX').format(sumaBarcoOp);
    if (this.barcoCheck) {
      sumaBarcoOp = sumaBarcoOp * 2;
      this.sumaBarco = Intl.NumberFormat('es-MX').format(sumaBarcoOp);
    }
    let sumaTaxiOp = this.taxiCosto * this.taxiViajes;
    this.sumaTaxi = Intl.NumberFormat('es-MX').format(sumaTaxiOp);
    if (!sumaTaxiOp) {
      sumaTaxiOp = 0;
      this.sumaTaxi = 0;
    }
    let sumaOtroOp = this.otroCosto * this.otroViajes;
    this.sumaOtro = Intl.NumberFormat('es-MX').format(sumaOtroOp);
    if (!this.sumaOtro) {
      sumaOtroOp = 0;
      this.sumaOtro = 0;
    }
    this.sumaTrasladosTotal = sumaAutobusOp + sumaAvionOp + sumaBarcoOp + sumaTaxiOp + sumaOtroOp;
    this.sumaTrasladosTotalImp = Intl.NumberFormat('es-MX').format(this.sumaTrasladosTotal);
    this.jornadas();
    this.sumaConceptosVarios();
  }
  // Traslados mano de obra

  // Seccion de fletes
  // Esta funcion solo es para hacer el despliegue del div
  desplegarFlete() {
    if (this.fletesCollapse) {
      this.fletesCollapse = false;
      this.iconoFlete = 'mdi-arrow-down-bold-circle-outline';
    } else {
      this.generarFlete();
      this.fletesCollapse = true;
      this.iconoFlete = 'mdi-arrow-up-bold-circle-outline';
    }
  }

  // Fletes viáticos
  fletesViaticos () {
    // Acarreos
    this.acarreosTotal = this.alojamientoDias * this.alojamientoInput;
    this.acarreosTotalImp = Intl.NumberFormat('es-MX').format(this.acarreosTotal);
    // Desayunos
    this.desayunosTotal = this.desayunosDias * this.desayunosInput;
    this.desayunosTotalImp = Intl.NumberFormat('es-MX').format(this.desayunosTotal);
    // Comidas
    this.comidasTotal = this.comidasDias * this.comidasInput;
    this.comidasTotalImp = Intl.NumberFormat('es-MX').format(this.comidasTotal);
    // Cenas
    this.cenasTotal = this.cenasDias * this.cenasInput;
    this.cenasTotalImp = Intl.NumberFormat('es-MX').format(this.cenasTotal);
    // Total Viáticos
    this.totalViaticos = this.acarreosTotal + this.desayunosTotal + this.comidasTotal + this.cenasTotal;
    this.totalViaticosImp = Intl.NumberFormat('es-MX').format(this.totalViaticos);
    // Total
    // this.totalFletes = this.totalViaticos + this.totalFletesTraslados + Number(this.operacionTotalVehiculares);
    // Mandar a llamar al método que involucra sub total y total
    // this.operacionTotalVehiculares = (this.gastoCombustible + Number(this.gastoCasetas) + Number(this.gastoExtra)).toFixed(2);
    this.totalFletes = Number((this.operacionTotalVehiculares + this.totalViaticos).toFixed(2));
    this.totalFletesImp = Intl.NumberFormat('es-MX').format(this.totalFletes);
    this.sumaTotales();
  }
  // Fletes viáticos

  // Fletes traslados
  fletesTraslados () {
    // Avión fletes
    this.subTotalAvionFletes = this.fletesAvion * this.fAvionInput;
    // Autobús fletes
    this.subTotalAutobusFletes = this.fletesAutobuses * this.fAutobusInput;
    // Taxis fletes
    this.subTotalTaxiFletes = this.fletesTaxis * this.fTaxiInput;
    // Otro fletes
    this.subTotalOtroFletes = this.fletesOtro * this.fOtroInput;
    // Total Traslados
    this.totalFletesTraslados = this.subTotalAvionFletes + this.subTotalAutobusFletes + this.subTotalTaxiFletes + this.subTotalOtroFletes;
    // Total
    // this.totalFletes = this.totalViaticos + this.totalFletesTraslados + Number(this.operacionTotalVehiculares);
    const fletesTotal =  (this.distanciaKm * .75) /* Apoyo a Operador */  + Number((this.operacionTotalVehiculares + this.totalViaticos + this.totalFletesTraslados).toFixed(2));
    // Utilidad del 35 %
    this.totalFletes = Number((this.operacionTotalVehiculares + this.totalViaticos).toFixed(2));
    this.totalFletesImp = Intl.NumberFormat('es-MX').format(this.totalFletes);
    // Mandar a llamar al método que involucra sub total y total
    // this.manoDeObra();
  }
  // Fletes traslados

  // Generar Flete
  generarFlete() {

    let vehiculo2Id;
    let vehiculo2CombustiblePrecio;
     let vehiculo2TrabajoReal;

    switch (true) {
      case this.sumaPeso >= 0 && this.sumaPeso < 1000: {
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 1000);
        // this.salarioChofer = 422;
        this.banderaVehiculo2 = false;
        break;
      }
      case this.sumaPeso >= 1000 && this.sumaPeso <= 3500: {
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3500);
        if ( this.sumaPeso >= 1000 && this.sumaPeso <= 3300 ) {
          // Silverado 3500
          this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3300);
        } else {
          // Ford F350
          this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3500);
        }
        // this.salarioChofer = 422;
        this.banderaVehiculo2 = false;
        break;
      }
      case this.sumaPeso > 3500 && this.sumaPeso <= 8000: {
        console.log(this.sumaPeso);
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 8000);
        // this.salarioChofer = 422;
        // this.salarioAyudanteGene = 333.35;
        this.banderaVehiculo2 = false;
        break;
      }
      case this.sumaPeso > 8000 && this.sumaPeso <= 12000: {
        console.log(this.sumaPeso);
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 12000);
        // this.salarioChofer = 422;
        // this.salarioAyudanteGene = 333.35;
        this.banderaVehiculo2 = false;
        break;
      }
      case this.sumaPeso > 12000 && this.sumaPeso <= 40000: {
        console.log(this.sumaPeso);
        this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 40000);
        // this.salarioChofer = 422;
        // this.salarioAyudanteGene = 333.35;
        this.banderaVehiculo2 = false;
        break;
        }
        case this.sumaPeso > 40000: {
          // daremos el pago de los chiferesayudantes
          // this.salarioChofer = 422;
          // this.salarioAyudanteGene = 333.35; 
          // primero hacemos la dierencia del peso total para poder hacer un calculo de un nuevo vehiculo
          const diferenciaPeso = this.sumaPeso - 40000;
          // en base al peso de la diferencia, buscaeremos el vehiculo...
          this.vehiculo = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 40000);
          this.banderaVehiculo2 = true;
          switch (true) {
            case diferenciaPeso > 0 && diferenciaPeso < 1000: {
              this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 1000);
              // this.salarioChofer = this.salarioChofer + 422;
              break;
            }
            case diferenciaPeso >= 1000 && diferenciaPeso <= 3500: {
              this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3500);
              if ( diferenciaPeso >= 1000 && diferenciaPeso <= 3300 ) {
                // Silverado 3500
                this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3300);
              } else {
                // Ford F350
                this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 3500);
              }
              // this.salarioChofer = this.salarioChofer + 422;
              break;
            }
            case diferenciaPeso > 3500 && diferenciaPeso <= 8000: {
              console.log(this.sumaPeso);
              this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 8000);
              // this.salarioChofer = this.salarioChofer + 422;
              // this.salarioAyudanteGene = this.salarioAyudanteGene + 333.35; 
              break;
            }
            case diferenciaPeso > 8000 && diferenciaPeso <= 12000: {
              console.log(this.sumaPeso);
              this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 12000);
              // this.salarioChofer = this.salarioChofer + 422;
              // this.salarioAyudanteGene = this.salarioAyudanteGene + 333.35;
              break;
            }
            case diferenciaPeso > 12000 && diferenciaPeso <= 40000: {
              console.log(this.sumaPeso);
              this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 40000);
              // this.salarioChofer = this.salarioChofer + 422;
              // this.salarioAyudanteGene = this.salarioAyudanteGene + 333.35;
              break;
              }
              case diferenciaPeso > 40000 && diferenciaPeso <= 200000: {
                console.log(this.sumaPeso);
                this.vehiculo2 = this.arrayVehiculos.find(row => row.vehiculoCapacidad === 40000);
                // this.salarioChofer = this.salarioChofer + 422;
                // this.salarioAyudanteGene = this.salarioAyudanteGene + 333.35;
                break;
                }
            }
        }
      default:
    }
    this.vehiculoId = this.vehiculo.vehiculoId;
    this.vehiculoNombre = this.vehiculo.vehiculoTipo;
    this.vehiculoCombustiblePrecio = this.vehiculo.vehiculoCombustible.precio;
    this.vehiculoTrabajoReal = this.vehiculo.vehiculoRendimiento.trabajoReal;
    // this.vehiculoCombustibleTipo = this.vehiculo.vehiculoCombustible.tipo;
    // this.vehiculoPrecio = this.vehiculo.vehiculoPrecio;

    if (this.banderaVehiculo2) {
      vehiculo2Id = this.vehiculo2.vehiculoId;
      this.vehiculo2Nombre = this.vehiculo2.vehiculoTipo;
      vehiculo2CombustiblePrecio = this.vehiculo2.vehiculoCombustible.precio;
      vehiculo2TrabajoReal = this.vehiculo2.vehiculoRendimiento.trabajoReal;
    }

    let mantenimiento = 0;

    // let estacionamiento = 0;

    // let lavadodeVehiculo = 0;

    // A
    this.distanciaMetros = $('#distanciaM').val();

    this.distanciaKm = (this.distanciaMetros) / 1000;
    this.distanciaKmImp = Intl.NumberFormat('es-MX').format(this.distanciaKm);
    // Condicional para agregar el colchón
    if (Number(this.sumaPeso)  === 0) {
      this.distanciaRedonda = 0;
      this.salarioChofer = 0;
    } else {
      this.distanciaRedonda = Number(((this.distanciaKm * 2) + 50).toFixed(2));
       mantenimiento = 2.17 * this.distanciaRedonda;

      // estacionamiento = 200;
      // lavadodeVehiculo = 200;

      if (this.banderaVehiculo2) {
        mantenimiento = 2 * mantenimiento;

      // estacionamiento = estacionamiento + 200;
      // lavadodeVehiculo = lavadodeVehiculo + 200;
      }
    }
    // this.sumaPeso  === 0 ? this.distanciaRedonda = 0 : this.distanciaRedonda = this.distanciaKm + 50;
    // Condicional para agregar el colchón
    this.gastoCombustible = (this.distanciaRedonda * this.vehiculoCombustiblePrecio) / this.vehiculoTrabajoReal;

    if (this.banderaVehiculo2) {
      this.gastoCombustible = this.gastoCombustible + ((this.distanciaRedonda * vehiculo2CombustiblePrecio) / vehiculo2TrabajoReal);
    }
    this.gastoCombustibleVista = Number((this.gastoCombustible).toFixed(2));
    this.gastoCombustibleVistaImp = Intl.NumberFormat('es-MX').format(this.gastoCombustibleVista);
    // this.gastoCombustible = (this.distanciaRedonda * this.precioGasolina) / this.rendimiento;

    // costo Mantenimiento

    // A
    // Operaciones
    // this.operacionTrabajoReal = (this.vehiculoCombustiblePrecio * this.distanciaRedonda) / this.vehiculoTrabajoReal;

    // this.operacionTotalVehiculares = this.gastoCombustible + Number(this.gastoCasetas) + Number(this.gastoExtra) + mantenimiento + estacionamiento + lavadodeVehiculo + this.salarioChofer + this.salarioAyudanteGene;
    this.operacionTotalVehiculares = this.gastoCombustible + Number(this.gastoCasetas) + Number(this.gastoExtra) + mantenimiento;
    // utilidad 

    this.operacionTotalVehiculares = (this.operacionTotalVehiculares * .10) + this.operacionTotalVehiculares;

    // imprevisto 10 por ciento

    this.operacionTotalVehiculares = (this.operacionTotalVehiculares * .5) + this.operacionTotalVehiculares;

    if (this.checkRecoleccion) {
      this.operacionTotalVehiculares = this.operacionTotalVehiculares * 2;
    }

      if (this.conFlete === 'true' && (this.ordenTipo === 'Venta' || this.ordenTipo === 'Renta' )) {
        this.operacionTotalVehiculares = 0;
      }

    this.operacionTotalVehicularesVista = Number(this.operacionTotalVehiculares).toFixed(2);
    this.operacionTotalVehicularesVistaImp = Intl.NumberFormat('es-MX').format(this.operacionTotalVehicularesVista);
    // this.operacionTotalVehiculares = (this.gastoCombustible + Number(this.gastoCasetas) + Number(this.gastoExtra)).toFixed(2);
    this.totalFletes = Number((this.operacionTotalVehiculares + this.totalViaticos).toFixed(2));
    this.totalFletesImp = Intl.NumberFormat('es-MX').format(this.totalFletes);
    // Mandar a llamar al método que involucra sub total y total

    for (const rowProductos of this.arrayProductos) {
      let rowCodigo;
      let rowDescripcion;
      let rowCantidadSolicitada;
      let rowCantidadAFisico;
      let rowOriginalAFisico;
      let rowCantidadFaltante;
      rowCodigo = rowProductos.codigo;
      rowDescripcion = rowProductos.descripcion;
      rowCantidadSolicitada = rowProductos.cantidad;
      rowOriginalAFisico = rowProductos.aFisico;
      // Operaciones
      rowCantidadAFisico = rowProductos.aFisico - this.cantidadColchon;
      rowCantidadFaltante = Math.abs((rowCantidadAFisico) - rowCantidadSolicitada);
    }
    this.sumaConceptosVarios();
    this.sumaTotales();
  }

  // Agregar producto
  agregarProducto(producto) {
    // console.log( this.arrayMaterial );
    const codigoProducto = producto.codigo;
    const descripcionProducto = producto.descripcion;
    const precioVenta = producto.pVenta.toFixed(2);
    const precioRentaMensual = producto.pRenta.toFixed(2);
    const pesoUnitario = producto.peso;
    const familia = producto.familia;
    // const familia = producto.familia;
    const productoPorCodigo = this.arrayMaterial.find( elemento => elemento.codigo == codigoProducto);
    if (!productoPorCodigo) {
      this.arrayMaterial.push({
        id: producto.materialId,
        // id: producto.id,
        codigo: codigoProducto,
        descripcion: descripcionProducto,
        peso: pesoUnitario,
        cantidad: 0,
        venta: precioVenta,
        rentaMensual: precioRentaMensual,
        familia: familia,
        rentaMensualSinModificadores: precioRentaMensual,
        // rentaMensualSinModificaciones: productos.rentaMensualSinModificaciones,
        importeRenta: 0,
        importeVenta: 0,
        importePeso: 0
      });
      // console.log(this.arrayMaterial);
    } else {
      swal('Producto en lista', 'Ya tienes un producto con el mismo codigo', 'warning');
    }
    this.aumento();
  }
  // Agregar producto

  // Calculos producto
  calculosProducto (producto) {
    const cantidad: Number = $('#' + producto.codigo).val();
    let productoSeleccionado;
    productoSeleccionado = this.arrayMaterial.find(row => row.codigo === producto.codigo);
    // Obtener elementos para cálculos
    // Importe Renta
    const precioRenta = productoSeleccionado.rentaMensual;
    const importeRenta = Number(cantidad) * precioRenta;
    // Calculo importe venta
    const precioVenta = productoSeleccionado.venta;
    const importeVenta = Number(cantidad) * precioVenta;
    // Peso Total
    const pesoUnitario = productoSeleccionado.peso;
    const pesoTotal = Number(cantidad) * pesoUnitario;
    // Insertar cálculos a array Materiales
    productoSeleccionado.cantidad = cantidad;
    // ====== Aumento a producto unitario =============
    // ====== Aumento a producto unitario =============
    // productoSeleccionado.importeR = importeRenta;
    if (this.porcentajeAumento !== 0) {
      const multi = Number(productoSeleccionado.rentaMensualSinModificadores * Number(this.porcentajeAumento / 100)) + Number(productoSeleccionado.rentaMensualSinModificadores);
    productoSeleccionado.importeRenta = Number(cantidad) * Number(multi);
    } else {
      productoSeleccionado.importeRenta = Number(cantidad) * Number(productoSeleccionado.rentaMensual);
    }

    productoSeleccionado.importeVenta = (importeVenta).toFixed(2);
    productoSeleccionado.importePeso = (pesoTotal).toFixed(2);
    // Se recorrerá el arreglo de productos buscando sus sumas totales
    // Se utilizan variables globales para poder mostrar el valor en la vista
    this.generarManoDeObra();
    this.calcularCostosProducto();
  }
  // Calculos producto

  // Calcular costos producto
  calcularCostosProducto() {
    this.sumaRenta = 0;
    this.sumaCantidad = 0;
    this.sumaPeso = 0;
    this.sumaVenta = 0;
    this.arrayMaterial.forEach(element => {
      this.sumaVenta = Number((this.sumaVenta + Number(element.importeVenta)).toFixed(2));
      this.sumaVentaImp = Intl.NumberFormat('es-MX').format(this.sumaVenta);
      // this.sumaRenta = this.sumaRenta + Number(element.importeRenta);
      this.sumaRenta = Number((Math.round(this.sumaRenta + Number(element.importeRenta))).toFixed(2));
      this.sumaRentaImp = Intl.NumberFormat('es-MX').format(this.sumaRenta);
      // this.sumaRenta = element.importeR;
      this.sumaCantidad = this.sumaCantidad + Number(element.cantidad);
      this.sumaCantidadImp = Intl.NumberFormat('es-MX').format(this.sumaCantidad);
      this.sumaPeso = Number((this.sumaPeso + Number(element.importePeso)).toFixed(2));
      this.sumaPesoImp = Intl.NumberFormat('es-MX').format(this.sumaPeso);
      // ==//==
    });
    // Renta diaria
    this.rentaDiaria = Number((this.sumaRenta / 30).toFixed(2));
    this.rentaDiariaImp = Intl.NumberFormat('es-MX').format(this.rentaDiaria);
    // Renta 7 días
    this.rentaSDias = Number((this.sumaRenta / 30 * 7).toFixed(4));
    this.rentaSdiasImp = Intl.NumberFormat('es-MX').format(this.rentaSDias);
    // Renta 15 días
    this.rentaQDias = Number((this.sumaRenta / 2).toFixed(4));
    this.rentaQdiasImp = Intl.NumberFormat('es-MX').format(this.rentaQDias);
    //    this.porcentajeAumento();
    // Aumento a producto unitario
    // const importeAProducto = productoSeleccionado.precioR;
    // this.aumentoProducto = Math.abs(Number(importeAProducto) * Number(this.porcentajeAumento) / 100 + Number(importeAProducto));
    // Aumento a producto unitario
    this.renta();
  }
  // Calcular costos producto
  aumento () {
    // console.log(this.arrayMaterial);
    this.arrayMaterial.forEach(e => {
        const rmsm = e.rentaMensualSinModificadores;
        const multi = Number(rmsm * (this.porcentajeAumento / 100)) + Number(e.rentaMensualSinModificadores);
        e.rentaMensual = multi.toFixed(3);
        e.importeRenta = (multi * e.cantidad).toFixed(3);
    });
    this.calcularCostosProducto();
  }

  // Suma Totales
  sumaTotales () {
    // this.descuento();
    // this.subTotal = Number((Number(this.sumaRenta) + this.totalTotal + this.fletesTotal).toFixed(4));
    this.subTotal = Number(Number(this.resultadoDiasRenta + this.totalTotal + this.totalFletes).toFixed(4));
    this.subtotalImp = Intl.NumberFormat('es-MX').format(this.subTotal);
    this.descuento();
    this.costoVenta = Number(Number(this.sumaVenta + Number(this.sumaVenta * Number(this.iva))).toFixed(4));
    this.costoVentaImp = Intl.NumberFormat('es-MX').format(this.costoVenta);
    if(this.ordenTipo === 'Venta') {
      this.resultadoPorcentajeDescuento = 0;
      let costoTotalOp = Number((this.resultadoDescuentoVenta).toFixed(4));
      this.costoTotal = Intl.NumberFormat('es-MX').format(costoTotalOp);
    } else {
      let costoTotalOp = Number((Number(((Number(this.resultadoPorcentajeDescuento) * Number(this.iva)) + Number(this.resultadoPorcentajeDescuento)))).toFixed(4));
      this.costoTotal = Intl.NumberFormat('es-MX').format(costoTotalOp);
    }
    
  }
  // Suma totales

  // Descuento
  descuento () {
    // Math.abs devuelve la cantidad absoluta de la cantidad dada en el parámetro.
    // this.resultadoPorcentajeDescuento = Math.abs((this.sumaRenta * this. porcentajeDescuento) / 100 - this.sumaRenta);
    // this.resultadoPorcentajeDescuento = Number((Math.abs((this.resultadoDiasRenta * this.porcentajeDescuento) / 100 - this.resultadoDiasRenta)).toFixed(4));
    this.resultadoPorcentajeDescuento = Math.abs((this.subTotal - ((this.porcentajeDescuento / 100) * this.subTotal))).toFixed(4);
    this.resultadoPorcentajeDescuentoImp = Intl.NumberFormat('es-MX').format(this.resultadoPorcentajeDescuento);
    let totalSuma = this.subTotal + this.sumaVenta;
    this.resultadoDescuentoVenta = Math.abs((totalSuma - ((this.porcentajeDescuento / 100) * totalSuma)));
    this.resultadoDescuentoVenta = (this.resultadoDescuentoVenta + (this.resultadoDescuentoVenta * Number(this.iva))).toFixed(4);
  }
  // Descuento

  // Renta
  renta () {
    this.resultadoDiasRenta = Number((Math.abs(this.sumaRenta / 30) * this.diasDeRenta).toFixed(4));
    this.resultadoDiasRentaImp = Intl.NumberFormat('es-MX').format(this.resultadoDiasRenta);
    this.fechaFin = moment(this.fechaCotizacion).add('days', this.diasDeRenta).locale('es').format('LL');
    // this.fechaFin = moment(this.fechaCotizacion).add('days', this.diasDeRenta).format('DD-MM-YYYY');
    this.sumaTotales();
  }
  // Renta

  // Eliminar producto
  eliminarMaterial(producto) {
    // console.log(producto);
    if (producto.id) {
      console.log('con id');
      const json = {
      materialOrdenId: producto.id,
    };
    this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.material + '/' + this.API.user.eliminar,
      'POST',
      json
      ).subscribe((response: any) => {
        console.log(response);
        // swal('Correcto ' + response.Estatus, response.Mensaje, 'success');
        const materialRow = this.arrayMaterial.findIndex(columna => columna.codigo === producto.codigo);
        this.arrayMaterial.splice(materialRow, 1);
        this.calcularCostosProducto();
      }, err => {
        console.log(err);
      });
    } else {
      console.log('Sin id');
      swal('Correcto ', 'Material eliminado', 'success');
      const materialRow = this.arrayMaterial.findIndex(columna => columna.codigo === producto.codigo);
      this.arrayMaterial.splice(materialRow, 1);
      this.calcularCostosProducto();
    }

    this.generarManoDeObra();
  }
  // Eliminar producto

  // Enviar cotizador
  enviarCotizador () {
    // console.log(this.arrayMaterial);
    let banderaFlete = false;
    if (this.conFlete === 'true') {
      banderaFlete = true;
      // console.log(this.conFlete);
    }
    // console.log(typeof(this.idCotizacion));
    const jsonData = {
      ordenTrabajoId: this.idCotizacion,
      tipoCotizacion: this.ordenTipo,
      conFlete: banderaFlete,
      justificacion: this.formJustificacion,
      montaje: this.montaje,
      desmontaje: this.desmontaje,
      noFletes: 0,
      // costoFlete: this.unidadViaje,
      porcentajeDescuento: this.porcentajeDescuento,
      porcentajeAumento: this.porcentajeAumento,
      clienteCotizado: this.formCliente,
      contactoCotizado: this.formContacto,
      obraCotizada: this.formObra,
      descripcion: this.formDescripcion,
      telefonoCotizado: this.formTelefono,
      celularCotizado: this.formCelular,
      emailCotizado: this.formEmail,
      fechaCotizada: this.fechaFin,
      productos: this.arrayMaterial,
      cantidadDias: this.diasDeRenta,
      latitud: this.latitud,
      longitud: this.longitud,
      // Mano de obra
      manoObra: {
        altura: this.altura,
        personas: this.personas,
        jornal: this.jornales,
        accesos: this.Accesos,
        descargas: this.Descargas,
        tiemposMuertos: this.tiemposMuertos,
        acarreos: this.Acarreos,
        tiemposExtras: this.tiemposExtras,
        diasInhabiles: this.diasInhabiles,
        tramites: this.Tramites,
        certificados: this.Certificados,
        consumibles: this.consumibles,
        equipoSeguridad: this.equipoSeguridad,
        preparacionMaterial: this.Preparacion,
        imprevistos: this.Imprevistos,
        comidas: this.Comidas,
        avionCosto: this.avionCosto,
        avionViajes: this.avionViajes,
        avionCheck: this.avionCheck,
        autobusCosto: this.autobusCosto,
        autobusViajes: this.autobusViajes,
        autobusCheck: this.autobusCheck,
        barcoCosto: this.barcoCosto,
        barcoViajes: this.barcoViajes,
        barcoCheck: this.barcoCheck,
        taxiCosto: this.taxiCosto,
        taxiViajes: this.taxiViajes,
        otroCosto: this.otroCosto,
        otroViajes: this.otroViajes,
        nRendimiento: this.nRendimiento,
        rendimiento: this.rendimiento
      },
      // Fletes
      flete: {
        distancia: this.distanciaRedonda,
        fecha: this.fechaCotizacion,
        gastoCombustible: this.operacionTotalVehiculares,
        gastoCasetas: this.gastoCasetas,
        gastoExtra: this.gastoExtra,
        recoleccion: this.checkRecoleccion,
        operador: 1,
        vehiculoId: this.vehiculoId,
        dias: 1,
        viaticos: {
          alojamientoCosto: this.alojamientoInput,
          alojamientoDias: this.alojamientoDias,
          desayunoCosto: this.desayunosInput,
          desayunoDias: this.desayunosDias,
          comidaCosto: this.comidasInput,
          comidaDias: this.comidasDias,
          cenaCosto: this.cenasInput,
          cenaDias: this.cenasDias,
          avionCosto: this.fAvionInput,
          avionViajes: this.fletesAvion,
          autobusCosto: this.fAutobusInput,
          autobusViajes: this.fletesAutobuses,
          taxiCosto: this.fTaxiInput,
          taxiViajes: this.fletesTaxis,
          otroCosto: this.fOtroInput,
          otroViajes: this.fletesOtro,
        }
      }
      // Fletes
    };
    // console.log(jsonData);
     this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.cotizacion + '/editar',
      'POST',
      jsonData
    ).subscribe((response: any) => {
      console.log(response);
      this.loginLoader = false;
      if ( response.Estatus === 200 || response.Estatus === 201 ) {
        Swal('Correcto', 'Cotización guardada', 'success');
        this.ruta.navigate(['dashboard/verCotizaciones', this.idCotizacion]);
      } else {
        Swal('Error', response.Mensaje.Estatus, 'error');
      }
    }, err => {
      console.log(err);
      this.loginLoader = false;
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });

  }
  // Enviar cotizador

  // 4 Métodos
  // SOLICITAR LISTA DE CAMBIOS DE PRECIO
  solicitarCambioListaPrecios () {
    let llamada = this.network;
    let api = this.API;
    let generales = this.GENERALES;
    let usuarioNombre = this.usuario;
    let sucursalNombre = this.sucursalNombre;
    let idCotizacion = this.idCotizacion;
    let sendMessage = this.sendMessage;
    let chat = this.chat;
    swal({
      title: 'Atención',
      text: '¿Estás seguro de solicitar cambios en la lista de precios?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
    if (result.value) {
      // console.log( this.idCotizacion );
      const rutaCotizacion = this.idCotizacion;
      // console.log( rutaCotizacion );
      swal({
      title: 'Selecciona la sucursal',
      input: 'select',
      inputOptions: {
        '2': 'Vallejo',
        '4': 'Aguascalientes',
        '5': 'Guadalajara',
        '6': 'Puerto Vallarta',
        '7': 'La Paz',
        '8': 'Querétaro',
        '9': 'Cancún',
        '10': 'Los Cabos',
        '11': 'Tijuana',
        '12': 'Coatzacoalcos',
        '13': 'Mazatlán',
        '14': 'Tlaquepaque',
        '15': 'Cuernavaca',
        '16': 'Monterrey',
        '17': 'Toluca',
        '18': 'Culiacán',
        '19': 'Puebla',
        '20': 'Chiapas',
        '22': 'Mérida'
      },
      // inputPlaceholder: 'required',
      showCancelButton: true,
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
        if (value !== '') {
          resolve();
          // console.log( value );
        } else {
          reject('Necesitas seleccionar una sucursal');
        }
        });
      }
      }).then(function (result) {
      if (result.value) {
        const SoliJSON = {
          ordenTrabajoId: rutaCotizacion,
          lista: result.value
        };
        llamada.callSecureService(
        api.user.orden + '/' + api.user.cotizacion + '/' + api.user.precios + '/' + api.user.lista,
        'POST',
        SoliJSON)
        .subscribe((response: any) => {
        // console.log( response );
        if (response.Estatus === 201) {
          Swal('Correcto', response.Mensaje.strings, 'success');
          // Notificación
          let targets = response.Mensaje.notificacion;
          targets.forEach(e => {
            let target = e.target;
            let notificacionString = 'El usuario ' + usuarioNombre.userName + ' de la sucursal: '  + sucursalNombre + ' ha solicitado un cambio en la lista de precios.';
            let url = 'verCotizaciones/' + idCotizacion;
            let mensaje = {
              mensaje: notificacionString,
              usuario: usuarioNombre.userName,
              target: target,
              tipo: 'notificacion',
              url: url
            };
            chat.sendMsg(mensaje);
          });
          // Notificación
        } else {
          Swal('Error ' + response.Estatus, response.Mensaje, 'error');
        }
      }, err => {
        console.log(err);
        Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
      });
    }
      return result.value;
    });
    }
    return result.value;
    });
  }
  // SOLICITAR LISTA DE CAMBIOS DE PRECIOS

  // ACEPTAR SOLICITUD
  aceptarSolicitud () {
    swal({
      title: 'Atención',
      text: '¿Estás seguro de aceptar cambios en la lista de precios?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
    if (result.value) {
      const ASJSON = {
        cotizacionId: this.idCotizacion,
        solicitudListaId: this.solicitudListaId
      };
      this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.precios + '/' + this.API.user.aceptar,
      'POST',
      ASJSON)
      .subscribe((response: any) => {
        // console.log( response );
      if (response.Estatus === 201) {
        swal({
          title: 'Correcto',
          text: 'Cambio en la lista de precios aceptada correctamente',
          type: 'success'
        });
        // Notificación
        let targets = response.Mensaje.notificacion;
        targets.forEach(e => {
          let target = e.target;
          let notificacionString = 'El usuario ' + this.usuario.userName + ' de la sucursal: '  + this.sucursalNombre + ' ha autorizado tu solicitud de cambio en la lista de precios.';
          let url = 'verCotizaciones/' + this.idCotizacion;
          this.sendMessage(target, notificacionString, url);
        });
        // Notificación

        this.banderaDT = false;
        this.listarProductos();
        setTimeout(() => { this.cambioMaterialPrecios(); }, 500);

        } else {
            Swal('Error ' + response.Estatus, response.Mensaje, 'error');
        }
      }, err => {
      console.log(err);
      Swal('Error', this.GENERALES.algoOcurrio, 'error');
      }
      );
    }
    });
  }
  // ACEPTAR SOLICITUD

  // FUNCION PARA CAMBIAR PRECIOS
  cambioMaterialPrecios() {
    this.arrayMaterial.forEach(eM => {
      this.arrayListarProductos.forEach(nPrecios => {
        if (nPrecios.codigo === Number(eM.codigo)) {
          // eM.rentaMensual = nPrecios.pRenta;
          eM.rentaMensualSinModificadores = nPrecios.pRenta;
        this.calculosProducto(eM);
        }
      });
    });
    this.enviarCotizador();
  }
  // FUNCION PARA CAMBIAR PRECIOS

  // RECHAZAR SOLICITUD
  rechazarSolicitud () {
    swal({
      title: 'Atención',
      text: 'Estás por rechazar la solicitud de cambio de lista de precios',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
    if (result.value) {
      const RSJSON = {
        cotizacionId: this.idCotizacion,
        solicitudListaId: this.solicitudListaId
      };
      this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.precios + '/' + this.API.user.rechazar,
      'POST',
      RSJSON)
      .subscribe((response: any) => {
      // console.log( response );
      if (response.Estatus === 201) {
        swal({
        title: 'Correcto',
        text: response.Mensaje.strings,
        type: 'success'
      });
      // Notificación
      // let nombreCliente;
      // this.tipoCliente === 'FISICA' ? nombreCliente = this.nombreC + ' ' + this.paternoC : nombreCliente = this.razonSocial;
        let targets = response.Mensaje.notificacion;
        targets.forEach(e => {
          let target = e.target;
          let notificacionString = 'El usuario ' + this.usuario.userName + ' de la sucursal: '  + this.sucursalNombre + ' ha rechazado tu solicitud de cambio de lista de precios.';
          let url = 'verCotizaciones/' + this.idCotizacion;
          this.sendMessage(target, notificacionString, url);
        });
        // Notificación
        // this.ngOnInit();
      } else {
        Swal('Error ' + response.Estatus, response.Mensaje, 'error');
      }
      }, err => {
        console.log(err);
        Swal('Error', this.GENERALES.algoOcurrio, 'error');
      });
    }
    });
    }
    // RECHAZAR SOLICITUD

    // SOLICITAR DESCUENTO
    solicitarDescuento () {
      swal({
      title: 'Atención',
      text: '¿Estás seguro de solicitar cambios en la lista de precios?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
        }).then((result) => {
          if (result.value) {
            const SLTCotizacion = {
            cotizacionId: this.idCotizacion,
          };
        this.network.callSecureService(
        this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.precios + '/' + this.API.user.descuento,
        'POST',
        SLTCotizacion
        ).subscribe((response: any) => {
          // console.log(response);
          // const solicitudGenerada = response.Estatus;
          // console.log( solicitudGenerada );
          if (response.Estatus === 201) {
            Swal('Correcto', response.Mensaje.strings, 'success');
            // Notificación
            let targets = response.Mensaje.notificacion;
            targets.forEach(e => {
              let target = e.target;
              let notificacionString = 'El usuario ' + this.usuario.userName + ' de la sucursal: '  + this.sucursalNombre + ' ha solicitado un descuento.';
              let url = 'verCotizaciones/' + this.idCotizacion;
              this.sendMessage(target, notificacionString, url);
            });
            // Notificación
            this.banderaDescuento = true;
          } else if (response.Estatus === 206 ) {
            Swal('Atención', response.Mensaje, 'info');
          }
        }, err => {
          console.log(err);
          Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
        });
      }
    });
  }
  // SOLICITAR DESCUENTO
  // REVISAR DESCUENTO
  revisarDescuento (arDescuento) {
    if (arDescuento === 'DESDENE') {
      this.porcentajeDescuento = 0;
    }
    const revDescuento = {
      codigo: arDescuento,
      cotizacionId: this.idCotizacion,
      porcentajeDescuento: this.porcentajeDescuento
    };
    this.network.callSecureService(
    this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.precios + '/' + this.API.user.descuento + '/' + this.API.user.autorizar,
    'POST',
    revDescuento
    ).subscribe((response: any) => {
    // console.log(response);
    if (response.Estatus === 201) {
      // console.log( response );
      Swal('Correcto', response.Mensaje.strings, 'success');
      // this.ruta.navigate(['dashboard/verCotizaciones', this.idCotizacion]);
      if ( this.estatusCotizacionDescuento === 'DESDENE' ) {
        // Notificación
        let targets = response.Mensaje.notificacion;
        targets.forEach(e => {
          let target = e.target;
          let notificacionString = 'El usuario ' + this.usuario.userName + ' de la sucursal: '  + this.sucursalNombre + ' ha rechazado un descuento.';
          let url = 'verCotizaciones/' + this.idCotizacion;
          this.sendMessage(target, notificacionString, url);
        });
        // Notificación
      } else if ( this.estatusCotizacionDescuento === 'DESAUTO' ) {
        // Notificación
        let targets = response.Mensaje.notificacion;
        targets.forEach(e => {
          let target = e.target;
          let notificacionString = 'El usuario ' + this.usuario.userName + ' de la sucursal: '  + this.sucursalNombre + ' ha aceptado un descuento.';
          let url = 'verCotizaciones/' + this.idCotizacion;
          this.sendMessage(target, notificacionString, url);
        });
        // Notificación
      }
      // ()
    }}, err => {
      console.log(err);
      Swal('Error ' + err.error.error.code, err.error.error.exception[0].message, 'error');
    });
  }
  // 4 Métodos

  cancelarDescuento() {
    const jsonData = {
      cotizacionId: this.idCotizacion
    };
    this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.precios + '/' + this.API.user.descuento + '/cancelar',
      'POST',
      jsonData
      ).subscribe((response: any) => {
        // console.log(response);
        swal('Descuento Cancelado', response.Mensaje, 'info');
        this.banderaDescuento = false;
      }, err => {
        console.log(err);
      }
    );
  }

  // Aceptar cotización

  prueba() {
    console.log( typeof(this.referencia));
    console.log( typeof(this.fechaObra));
    console.log( typeof(this.horaObra));
    console.log( this.referencia );
    console.log( this.fechaObra['formatted'] );
    console.log( this.horaObra );
  }

  aceptarCotizacion() {
    const JSON = {
      cotizacionId: this.idCotizacion,
      referencia: this.referencia,
      fechaObra: this.fechaObra['formatted'],
      horaObra: this.horaObra,
    };
    this.network.callSecureService(
      this.API.user.orden + '/' + this.API.user.cotizacion + '/' + this.API.user.aceptada,
      'POST',
      JSON
      ).subscribe((response: any) => {
        // console.log(response);
        swal('Correcto', response.Mensaje, 'success');
        this.banderaDescuento = false;
      }, err => {
        console.log(err);
      }
    );
  }
  // Aceptar cotización

  // Notificación
  sendMessage(target, notificacionString, url) {
    let mensaje = {
        mensaje: notificacionString,
        usuario: this.usuario.userName,
        target: target,
        tipo: 'notificacion',
        url: url
    };
   this.chat.sendMsg(mensaje);
  }
  // Notificación

  // Para imprimir
  print(): void {
    this.enviarCotizador();
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title></title>
          <style>
            .letraImprimir {
              font-family: Arial;
              font-weight: lighter;
              font-size: 12px;
            }
            .letraContratacion {
              font-family: Arial;
              font-weight: lighter;
              font-size: 9px;
            }
            .tablaIntegracionGastos{
              border-bottom: 1px solid black;
            }
            .tablas {
              border: 1px solid black;
            }
            .tablaMedida {
              width: 720px;
            }
            .tamagnoCeldas {
              height: 2px;
            }
            #lineaDivisora {
              border-left: 1px solid red;
              margin: 0px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
        <footer>
          <div style="text-align: right">
            <img src="../../../assets/images/sm8footer.jpg" alt="95px" width="120px">
          </div>
        </footer>
      </html>`
    );
    popupWin.document.close();
  }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/ver-cotizacion/ver-cotizacion.component.ts